import { Injectable } from '@angular/core';
import { AuthService as AuthServiceV1 } from '../../../shared/auth.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { SessionService } from '../session/session.service';
import { AppConfig } from 'src/app/shared/services/app-config';
import { MessageService } from 'src/app/shared/services';

@Injectable()
export class AuthService extends AuthServiceV1 {
  constructor(
    protected _http: HttpClient,
    protected _router: Router,
    protected _sessionService: SessionService,
    protected _messageService: MessageService,
    protected _config: AppConfig) {
    super(_http, _router, _sessionService, _messageService, _config);
  }
}
